/*
THIS FILE IS AUTO-GENERATED, NO MANUAL CHANGES IS ALLOWED
*/

import { isOfErrorType } from '@atlas/shared/data-access/shared';
import axios, { type AxiosError } from 'axios';
import type {
    BadRequestProblemDetailModel,
    ProblemDetailsModel,
    UnauthorizeProblemDetailModel,
    ValidationProblemDetailsModel
} from '../../models/index';

export type ContentTranslationGetErrorModel = AxiosError<
    BadRequestProblemDetailModel | UnauthorizeProblemDetailModel | ProblemDetailsModel
>;

export type ContentReportPostErrorModel = AxiosError<
    BadRequestProblemDetailModel | UnauthorizeProblemDetailModel | ValidationProblemDetailsModel | ProblemDetailsModel
>;

export class ContentServiceErrorGuards {
    static ContentTranslationGet = class {
        static isBadRequestProblemDetail = (
            error: ContentTranslationGetErrorModel | unknown
        ): error is AxiosError<BadRequestProblemDetailModel> => {
            return axios.isAxiosError(error) && isOfErrorType<BadRequestProblemDetailModel>(error, 400);
        };
        static isUnauthorizeProblemDetail = (
            error: ContentTranslationGetErrorModel | unknown
        ): error is AxiosError<UnauthorizeProblemDetailModel> => {
            return axios.isAxiosError(error) && isOfErrorType<UnauthorizeProblemDetailModel>(error, 401);
        };
        static isProblemDetails = (
            error: ContentTranslationGetErrorModel | unknown
        ): error is AxiosError<ProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<ProblemDetailsModel>(error, 500);
        };
    };

    static ContentReportPost = class {
        static isBadRequestProblemDetail = (
            error: ContentReportPostErrorModel | unknown
        ): error is AxiosError<BadRequestProblemDetailModel> => {
            return axios.isAxiosError(error) && isOfErrorType<BadRequestProblemDetailModel>(error, 400);
        };
        static isUnauthorizeProblemDetail = (
            error: ContentReportPostErrorModel | unknown
        ): error is AxiosError<UnauthorizeProblemDetailModel> => {
            return axios.isAxiosError(error) && isOfErrorType<UnauthorizeProblemDetailModel>(error, 401);
        };
        static isValidationProblemDetails = (
            error: ContentReportPostErrorModel | unknown
        ): error is AxiosError<ValidationProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<ValidationProblemDetailsModel>(error, 422);
        };
        static isProblemDetails = (
            error: ContentReportPostErrorModel | unknown
        ): error is AxiosError<ProblemDetailsModel> => {
            return axios.isAxiosError(error) && isOfErrorType<ProblemDetailsModel>(error, 500);
        };
    };
}
